import {
    faCalendar,
    faComments,
    faFile,
    faFileCircleCheck,
    faCopy,
    faFilePdf,
    faPen,
    faEnvelope,
    faTimeline, faTrashAlt,
} from '@fortawesome/free-solid-svg-icons';
import useAuthz from 'hooks/useAuthz';
import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate } from 'react-router';
import ModalViewDetails from '../../views/Dossier/ModalViewDetails';
import ModalViewTchats from '../../views/Dossier/ModalViewTchats';
import SearchIcon from '@mui/icons-material/Search';
import ModalViewMessages from '../../views/Dossier/ModalViewMessages';
import ModalViewAgreements from '../../views/Dossier/ModalViewAgreements';
import MyDialog from '../Layout/MyDialog';
import axios from 'axios';
import { URL_API } from '../../utils/globalConfig';
import { logError } from '../Utils/FormatData';
import { FACTURATION_TYPE, PROFIL, REQUEST_PASS_STATUS, REQUEST_PASS_TYPE } from '../../constants/enum';
import ModalDeleteRequestConfirmation from '../Dossier/ModalDeleteRequestConfirmation';
import ModalCancelRequestConfirmation from '../Dossier/ModalCancelRequestConfirmation';

const ActionsRequestPassRenderer = (props) => {
    const [authz, user, profil] = useAuthz();
    const [openModal, setOpenModal] = useState(false);
    const [openTchatModal, setOpenTchatModal] = useState(false);
    const [openMessageModal, setOpenMessageModal] = useState(false);
    const [openAgreementsModal, setOpenAgreementsModal] = useState(false);
    const [openConfirmDeleteRequestModal, setOpenConfirmDeleteRequestModal] = useState(false);
    const [openConfirmCancelRequestModal, setOpenConfirmCancelRequestModal] = useState(false);
    const [contractId, setContractId] = useState(null);
    const [showDevis, setShowDevis] = useState(false);
    const [unreadMessages, setUnreadMessages] = useState(false);
    // GATE-19 : verrou d'édition
    const [lockConflictModal, setLockConflictModal] = useState(false);
    const navigate = useNavigate();

    const createOrDisplayBill = () => {
        navigate(`/facturation?id=${props.data.id}&type=devis`);
    };

    const createOrEditSchedule = () => {
        navigate(`/planification?id=${props.data.id}&client=${props.data.metadata.complementIdentite.transporteur}`);
    };

    const apiGetContract = () => {
        axios({
            method: 'get',
            url: URL_API + '/demande-passage/verifier-accords-principe',
            params: { requestId: props.data.id },
        })
        .then((response) => {
            setContractId(response.data);
        })
        .catch((error) => {
            logError(alert, error);
        });
    };

    const apiGetUnreadMessages = () => {
        axios({
            method: 'get',
            url: URL_API + '/messagerie/dossier-messages-non-lus',
            params: { requestPassId: props.data.id, userAction: user.user_id },
        })
        .then((response) => {
            setUnreadMessages(response.data);
        })
        .catch((error) => {
            logError(alert, error);
        });
    };

    const apiGetDevis = () => {
        let display = false;

        if (props.data.facturations) {
            let facturations = props.data.facturations.filter(fact => fact.deleted === false);
            facturations.some((fact) => {
                if (fact.elements_factures?.status?.pdfAvailable) {
                    display = true;
                    return true;
                }
            });
        }

        setShowDevis(display);
    };

    useEffect(() => {
        apiGetContract();
        apiGetDevis();
        apiGetUnreadMessages();
    }, []);

    // GATE-19 : vérifie le verrou avant navigation vers l'édition
    const handleEditClick = () => {
        const willEdit = (
            (profil.profil === 5 && (
                props.data.id_status === REQUEST_PASS_STATUS.WAITING_CLIENT ||
                props.data.id_status === REQUEST_PASS_STATUS.WAITING_INTERN ||
                props.data.id_status === REQUEST_PASS_STATUS.ON_GOING ||
                props.data.id_status === REQUEST_PASS_STATUS.NEW
            )) || profil.profil === 1 || profil.profil === 2 || profil.profil === 3
        );

        if (!willEdit) {
            // Mode consultation : pas de verrou, navigation directe
            navigate(`/demande-passage/dossier?id=${props.data.id}`);
            return;
        }

        axios({
            method: 'POST',
            url: `${URL_API}/demande-passage/${props.data.id}/lock/acquire`,
            params: { userAction: user.user_id },
        })
        .then(() => {
            navigate(`/demande-passage/dossier?id=${props.data.id}`);
        })
        .catch((error) => {
            if (error.response && error.response.status === 423) {
                setLockConflictModal(true);
            } else {
                // En cas d'erreur inattendue, on laisse passer (la garde de sauvegarde prend le relais)
                navigate(`/demande-passage/dossier?id=${props.data.id}`);
            }
        });
    };

    return (
        <div>
            {
                <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
                    {!(props.fromRequestPass) &&
                        <div className='buttons-request-table' style={{ backgroundColor: '#a5c946' }}
                             title='Accéder au dossier'
                             onClick={handleEditClick}>
                            {(profil.profil === 5 && (props.data.id_status === REQUEST_PASS_STATUS.WAITING_CLIENT || props.data.id_status === REQUEST_PASS_STATUS.WAITING_INTERN || props.data.id_status === REQUEST_PASS_STATUS.ON_GOING ||  props.data.id_status === REQUEST_PASS_STATUS.NEW)) || (profil.profil === 1 || profil.profil === 2 || profil.profil === 3) ?
                                <FontAwesomeIcon icon={faPen} style={{ color: '#ffffff', height: '12px' }} /> :
                                <SearchIcon style={{ color: '#ffffff', height: '12px' }} />
                            }
                        </div>
                    }
                    <div className='buttons-request-table' style={{ backgroundColor: '#a5c946' }}
                         title='Historique du dossier' onClick={() => setOpenModal(true)}>
                        <FontAwesomeIcon icon={faTimeline}
                                         style={{ color: '#ffffff', height: '12px', transform: 'rotateZ(90deg)' }} />
                    </div>
                    {!(props.fromRequestPass) &&
                        <div className='buttons-request-table'
                             style={{ backgroundColor: '#a5c946', position: 'relative' }} title='Tchat'
                             onClick={() => setOpenTchatModal(true)}>
                            {unreadMessages &&
                                <div id='num-message-dossier' />
                            }
                            <FontAwesomeIcon icon={faComments} style={{ color: '#ffffff', height: '12px' }} />
                        </div>
                    }
                    {!(props.fromRequestPass) && (props.data.metadata.reference.typeDemande === REQUEST_PASS_TYPE.SUPERIEUR) && (profil.profil === PROFIL.ADMINISTRATEUR || profil.profil === PROFIL.GESTIONNAIRE || profil.profil === PROFIL.CLIENT) &&
                        <div className='buttons-request-table' style={{ backgroundColor: '#a5c946' }}
                             title='Dupliquer le dossier'
                             onClick={() => navigate(`/demande-passage/dossier?duplicate=${props.data.id}`)}>
                            <FontAwesomeIcon icon={faCopy} style={{ color: '#ffffff', height: '12px' }} />
                        </div>
                    }
                    <div className='buttons-request-table' style={{ backgroundColor: '#0094ca' }} title='Messagerie'
                         onClick={() => setOpenMessageModal(true)}>
                        <FontAwesomeIcon icon={faEnvelope} style={{ color: '#ffffff', height: '12px' }} />
                    </div>
                    {((props.data.id_status >= REQUEST_PASS_STATUS.VALIDATED && props.data.id_status !== REQUEST_PASS_STATUS.REFUSED) && (profil.profil !== 5 || (profil.profil === 5 && showDevis))) &&
                        <div className='buttons-request-table' style={{ backgroundColor: '#f18d2d' }}
                             title='Devis / Facture' onClick={() => createOrDisplayBill()}>
                            <FontAwesomeIcon icon={faFilePdf} style={{ color: '#ffffff', height: '12px' }} />
                        </div>
                    }
                    {((props.data.id_status >= REQUEST_PASS_STATUS.NEW && ![REQUEST_PASS_STATUS.BLOCKED, REQUEST_PASS_STATUS.REFUSED, REQUEST_PASS_STATUS.TERMINATED, REQUEST_PASS_STATUS.CANCELLED].includes(props.data.id_status) && props.data.metadata.reference.typeDemande !== REQUEST_PASS_TYPE.SUPERIEUR) ||
                            (props.data.incomplete && props.data.id_status !== REQUEST_PASS_STATUS.CANCELLED && props.data.id_status !== REQUEST_PASS_STATUS.BLOCKED && props.data.id_status !== REQUEST_PASS_STATUS.REFUSED && props.data.metadata.reference.typeDemande !== REQUEST_PASS_TYPE.SUPERIEUR)) &&
                        <div className='buttons-request-table' style={{ backgroundColor: '#bb0060c4' }}
                             title='Planification' onClick={() => createOrEditSchedule()}>
                            <FontAwesomeIcon icon={faCalendar} style={{ color: '#ffffff', height: '12px' }} />
                        </div>
                    }

                    {(profil.profil === 1 || profil.profil === 2 || (contractId && (profil.profil === 3 || profil.profil === 5))) && (props.data.id_status >= REQUEST_PASS_STATUS.SIGNED && props.data.id_status !== REQUEST_PASS_STATUS.REFUSED) &&
                        <div className='buttons-request-table' style={{ backgroundColor: '#0094ca' }}
                             title='Accords de principe' onClick={() => setOpenAgreementsModal(true)}>
                            <FontAwesomeIcon icon={faFileCircleCheck} style={{ color: '#ffffff', height: '12px' }} />
                        </div>
                    }

                    {(profil.profil === 5 && props.data.id_status === REQUEST_PASS_STATUS.NEW && props.data.planifications?.filter((planification) => !planification.deleted).length === 0) &&
                        <div className='buttons-request-table' style={{ backgroundColor: '#ea0000' }}
                             title='Annuler le dossier' onClick={() => setOpenConfirmCancelRequestModal(true)}>
                            <FontAwesomeIcon icon={faTrashAlt} style={{ color: '#ffffff', height: '12px' }} />
                        </div>
                    }
                </div>
            }

            <ModalViewDetails openModal={openModal} setOpenModal={setOpenModal} color={'#a5c946'} user={user}
                              dossier={props.data} profil={profil} />
            <ModalViewTchats openModal={openTchatModal} setOpenModal={setOpenTchatModal}
                             setNeedReload={props.setNeedReload} color={'#f18d2d'} user={user}
                             profil={profil} dossier={props.data} />
            <ModalViewAgreements openModal={openAgreementsModal} setOpenModal={setOpenAgreementsModal} color={'#0094ca'}
                                 user={user} profil={profil} dossier={props.data} contractId={contractId} />
            <ModalViewMessages openModal={openMessageModal} setOpenModal={setOpenMessageModal} color={'#0094ca'}
                               profil={profil} user={user} dossier={props.data} />
            <MyDialog
                open={lockConflictModal}
                handleClose={setLockConflictModal}
                title={null}
                content={"Attention : Ce dossier est en cours de modification par un autre utilisateur.\nIl est temporairement verrouillé. Il sera bientôt disponible à l'édition."}
                dialog={() => setLockConflictModal(false)}
                hideCloseBtn={true}
                trueButtonLabel="OK"
            />
            <ModalDeleteRequestConfirmation openModal={openConfirmDeleteRequestModal}
                                            setOpenModal={setOpenConfirmDeleteRequestModal}
                                            setNeedReload={props.setNeedReload}
                                            color={'#0094ca'} dossier={props.data} />
            <ModalCancelRequestConfirmation openModal={openConfirmCancelRequestModal}
                                            setOpenModal={setOpenConfirmCancelRequestModal}
                                            setNeedReload={props.setNeedReload}
                                            color={'#0094ca'} dossier={props.data} />
        </div>
    );

};

export default ActionsRequestPassRenderer;
